/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_4_DescInputs */

const en_mk_tb_step_4_desc = /** @type {(inputs: Mk_Tb_Step_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See milestones, blockers, review queues and updates that need your attention.`)
};

const id_mk_tb_step_4_desc = /** @type {(inputs: Mk_Tb_Step_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat milestone, hambatan, antrean review, dan pembaruan yang membutuhkan perhatian Anda.`)
};

/**
* | output |
* | --- |
* | "See milestones, blockers, review queues and updates that need your attention." |
*
* @param {Mk_Tb_Step_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_4_desc = /** @type {((inputs?: Mk_Tb_Step_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_4_desc(inputs)
	return en_mk_tb_step_4_desc(inputs)
});